export const generateImageUrl = (url) => {
  let imageUrl = '';

  if (url) {
    imageUrl = url.replace('123x321', '768x');
  }

  return imageUrl;
};

export const generateImageSrcset = (url) => {
  let imageSrcset = '';

  if (url) {
    imageSrcset = `${url.replace('123x321', '2000x')} 2000w, ${url.replace('123x321', '1440x')} 1440w, ${url.replace('123x321', '1024x')} 1024w, ${url.replace('123x321', '768x')} 768w, ${url.replace('123x321', '468x')} 468w, ${url.replace('123x321', '200x')} 200w`;
  }

  return imageSrcset;
};